/**
 * File Cookies.js
 */
/* eslint-disable */

const Cookies = () => {
    function setCookie(cname,cvalue,exdays) {
        exdays = exdays || 1;
        let d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        let expires = "expires=" + d.toGMTString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    function getCookie(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');

        for(let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    function checkCookie() {
        let popupShow = getCookie("popupCookies");
        let $popup = $('.cookies-popup');
        let $popupAgree = $('#cookiesAgree');
        let $popupClose = $('#cookiesClose');

        setTimeout(function(){
            $popup.addClass('active');

            if (popupShow != "") {
                $popup.removeClass('active');
            } else {
                $popupAgree.click(function(e){
                    e.preventDefault();
                    setCookie("popupCookies", 1, 60);
                    $popup.removeClass('active');
                });
                $popupClose.click(function(){
                    $popup.removeClass('active');
                });
            }
        }, 3500);
    }
    checkCookie();
};

export default Cookies;



// WEBPACK FOOTER //
// ./scripts/components/Cookies.js